import { AppDispatch, RootState } from "../store";
import { loadClients } from "../slices/clientSlice";
import { loadAgencies } from "../slices/agencySlice";
import { loadFields } from "../slices/fieldSlice";
import { loadSegments } from "../slices/segmentSlice";
import { loadClientManagerDescendants, loadUsers } from "../slices/userSlice";
import { loadFocusedCaseAllocation } from "../slices/focusedCaseAllocationSlice";

const clearReduxAndThunk = (clearToken: boolean) => async (dispatch: AppDispatch, _: () => RootState) => {
	if (clearToken) {
		localStorage.removeItem("token");
	}

	// Wait for all dispatches to finish
	await Promise.all([
		dispatch(loadClients([])),
		dispatch(loadAgencies([])),
		dispatch(loadFields([])),
		dispatch(loadSegments([])),
		dispatch(loadUsers([])),
		dispatch(loadClientManagerDescendants([])),
		dispatch(loadFocusedCaseAllocation([])),
	]);
};

export default clearReduxAndThunk;